<template>
  <div id="loading-page">
      <Loader v-if="loading" key="loader" />
  </div>
</template>

<script>
import Loader from '@/components/shared/Loader';
import SessionService from '@/services/api/session/session-service';
import AuthenticationService from '@/services/api/authentication/authentication-service';

export default {
  name: 'LoadingPage',
  components: {
    Loader,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    isCMI5() {
      const { standard, Standard } = this.$route.query;
      return standard === 'CMI5' || Standard === 'CMI5';
    },
  },
  methods: {
    startOtherSession() {
      /* eslint-disable */
      const { code, Code, ClientId, clientId, clientid, b, B, standard, Standard, AICC_URL, aicc_url, AICC_SID, aicc_sid, student_id, learner_id, parent_url } = this.$route.query;
      const aiccUrl = AICC_URL || aicc_url || parent_url;
      const aiccSid = AICC_SID || aicc_sid;
      const contentCode = code || Code;
      const client = ClientId || clientId || clientid;
      const type = standard || Standard;
      const userId = student_id || learner_id;
      /* eslint-enable */
      const body = {
        clientId: client,
        code: contentCode,
        lmsStandard: type,
        lmsUrl: aiccUrl,
        lmsSession: aiccSid,
        userId: userId,
      };
      SessionService.createSession(body, type).then(res => {
        localStorage.setItem('session', res.SyncGuid);
        this.loading = false;
        let path = `/Custom/${type}/${client}/${contentCode}`;
        if (process.env.NODE_ENV === 'local' && this.$route.query.authenticate) {
          path += '?authenticate=' + this.$route.query.authenticate;
        }
        this.$router.push(path);
      });
    },
    startCMI5Session() {
      /* eslint-disable */
      const { code, Code, ClientId, clientId, clientid, standard, Standard, endpoint, Endpoint, fetch, Fetch, actor, Actor, registration, Registration, activityId, ActivityId } = this.$route.query;
      const contentCode = code || Code;
      const client = ClientId || clientId || clientid;
      const type = standard || Standard;
      /* eslint-enable */
      const body = {
        clientId: client,
        code: contentCode,
        endpoint: endpoint || Endpoint,
        fetch: fetch || Fetch,
        actor: actor || Actor,
        registration: registration || Registration,
        activityId: activityId || ActivityId,
      };
      SessionService.createSession(body, type).then(res => {
        localStorage.setItem('session', res.SyncGuid);
        this.loading = false;
        this.$router.push(`/Custom/${type}/${client}/${contentCode}`);
      });
    },
    startSession() {
      if (this.isCMI5) {
        this.startCMI5Session();
      } else {
        this.startOtherSession();
      }
    },
  },
  mounted() {
    const sessionId = localStorage.getItem('session');
    const { standard, Standard, ClientId, clientId, clientid, code, Code } = this.$route.query;
    const type = standard || Standard;
    const client = ClientId || clientId || clientid;
    const contentCode = code || Code;
    if (sessionId === null) {
      this.startSession();
    } else {
      AuthenticationService.authenticated(contentCode).then(result => {
        if (result.isAuthenticated) {
          this.$router.push(`/Custom/${type}/${client}/${contentCode}`);
        } else {
          this.startSession();
        }
      }).catch(() => {
        this.startSession();
      });
    }
  },
};
</script>
